import React from "react";
import { ChevronRight } from "lucide-react";
import { getModeIcon } from "../../utils";
import { navigateTo } from "../../utils/navigation";

export default function index({
  item,
  name,
  time,
  badge,
  showJoinNow,
  imgUrl,
  isLast,
}) {
  const doNavigation = (item) => {
    const title = item.title ? encodeURIComponent(item.title) : "-";
    const firstName = item.firstName ? encodeURIComponent(item.firstName) : "-";
    const lastName = item.lastName ? encodeURIComponent(item.lastName) : "-";
    const date = encodeURIComponent(item.date || "");
    const startTime = encodeURIComponent(item.startTime || "");
    if (item.mode === "CHAT") {
    } else if (item.mode === "VIDEO" || item.mode === "AUDIO") {
      navigateTo(
        "/call/" +
        item.channel +
        "/" +
        item.mode +
        "/" +
        item.appointmentId +
        "/" +
        item.uid);
    } else {
      navigateTo(`/inPerson/${item.channel}/${item.mode}/${item.appointmentId}/${item.uid}/${title}/${firstName}/${lastName}/${date}/${startTime}`);
    }
  };
  return (
    <div className="flex flex-col">
      <div className="flex justify-between items-center py-1.5">
        <div className="flex items-center gap-2">
          <img
            src={imgUrl}
            alt="avatar"
            className="w-[44px] h-[44px] rounded-full object-cover flex-shrink-0"
          />
          <div className="flex flex-col">
            <h4 className="font-medium text-[#171717] text-sm font-poppins">
              {name}
            </h4>
            <p className="font-medium text-[#4B61FF] text-xs font-poppins">
              {time}
            </p>
          </div>
        </div>
        <div className="flex flex-col items-end gap-1.5 flex-shrink-0">
          <span className="flex flex-row items-center gap-1.5 text-[#2563EB] text-[11px] font-semibold px-2 py-0.5 rounded-full bg-[#EFF6FF] font-poppins">
            <img
              src={getModeIcon(badge)}
              alt={badge}
              className="w-[14px] h-[14px] object-contain"
            />
            {badge}
          </span>

          {showJoinNow ? (
            <p
              className="btn-gradient text-white h-[26px] mb-0 text-xs px-2.5 rounded-lg font-poppins cursor-pointer flex items-center justify-center"
              onClick={() => doNavigation(item)}
            >
              Join Now
            </p>
          ) : (
            <span
              role="button"
              title="View upcoming appointments"
              className="w-[26px] h-[26px] rounded-full bg-[#F1F5F9] hover:bg-[#E2E8F0] text-[#64748B] hover:text-[#171717] flex items-center justify-center cursor-pointer transition-colors"
              onClick={() => {
                navigateTo("/upcoming-appointments/upcoming");
              }}
            >
              <ChevronRight size={16} />
            </span>
          )}
        </div>
      </div>
      {!isLast && <div className="border-t-0.5 border-[#E2E8F0] mt-0 mb-0" />}
    </div>
  );
}
